import React, { useEffect, useRef, useState } from 'react';

import { Box, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TemplateFooter5New, TemplateFooter6New } from './Template5And6Redesign';

// Footer Variant 1 - Blue Professional with gradient
const FooterContainer1 = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1B365D 0%, #2B4A7A 100%)',
  padding: '14px 18px',
  borderRadius: '0 0 12px 12px',
  color: '#ffffff',
  position: 'relative',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: '0 2px 8px rgba(27, 54, 93, 0.3)'
}));

// Footer Variant 2 - Modern Glassmorphism Design
const FooterContainer2 = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(180deg, #133944 0%, #0d2a32 100%)',
  padding: '10px 12px',
  borderRadius: '0 0 12px 12px',
  color: '#ffffff',
  position: 'relative',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: '0 2px 12px rgba(19, 57, 68, 0.4)',
  overflow: 'hidden'
}));

const Card2 = styled(Box)(({ theme }) => ({
  borderRadius: '8px',
  background: 'rgba(255,255,255,.05)',
  border: '1px solid rgba(255,255,255,.14)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  padding: '8px 10px'
}));

const TileInner2 = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1.2fr',
  gap: '8px',
  alignItems: 'center'
}));

const Brand2 = styled(Box)(({ theme }) => ({
  lineHeight: 1.1
}));

const BrandTitle2 = styled(Typography)(({ theme }) => ({
  fontWeight: 800,
  letterSpacing: '-.01em',
  fontSize: '11px',
  color: '#fff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

const BrandTag2 = styled(Typography)(({ theme }) => ({
  marginTop: '2px',
  fontSize: '6px',
  opacity: 0.9,
  color: '#fff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

const Stack2 = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '6px'
}));

const Row2 = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gap: '4px',
  alignItems: 'center'
}));

const Icon2 = styled(Box)(({ theme }) => ({
  width: '16px',
  height: '16px',
  borderRadius: '999px',
  border: '1px solid rgba(255,255,255,.95)',
  display: 'grid',
  placeItems: 'center',
  flexShrink: 0,
  '& svg': {
    width: '10px',
    height: '10px',
    stroke: '#fff'
  }
}));

const ValueText2 = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '6px',
  color: '#fff',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

const AddressValue2 = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '6px',
  color: '#fff',
  lineHeight: 1.4,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
}));

// Footer Variant 4 - Purple with White Footer Section
const FooterContainer4 = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #c44fc4 0%, #8b4cb8 50%, #6b46c1 100%) !important',
  padding: '0',
  borderRadius: '0 0 12px 12px',
  color: '#ffffff',
  position: 'relative',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  boxShadow: '0 2px 12px rgba(107, 70, 193, 0.4)',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `
      radial-gradient(circle at 20% 20%, rgba(255,255,255,0.3) 2px, transparent 2px),
      radial-gradient(circle at 80% 30%, rgba(255,255,255,0.3) 2px, transparent 2px),
      radial-gradient(circle at 40% 10%, rgba(255,255,255,0.3) 2px, transparent 2px),
      radial-gradient(circle at 60% 15%, rgba(255,255,255,0.3) 2px, transparent 2px)
    `,
    backgroundSize: '100px 100px',
    zIndex: 1,
    pointerEvents: 'none'
  }
}));

const WhiteFootSection = styled(Box)(({ theme }) => ({
  background: 'white !important',
  width: '100%',
  padding: '12px 18px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  position: 'relative',
  zIndex: 10,
  overflow: 'hidden'
}));


// Footer Variant 6 - Auto-adjustable layout
const FooterContainer6 = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #003f92 0%, #0066cc 100%)',
  color: 'white',
  padding: '8px',
  borderRadius: '0 0 12px 12px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  alignItems: 'center',
  justifyContent: 'center'
}));

const PhoneSection6 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px',
  width: '100%'
}));

const PhoneIcon6 = styled(Box)(({ theme }) => ({
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#fff'
  }
}));

const PhoneNumber6 = styled(Typography)(({ theme }) => ({
  fontFamily: '"Montserrat", sans-serif',
  fontWeight: 600,
  color: '#ffffff',
  fontSize: '15px',
  lineHeight: 1.4,
  letterSpacing: '0.01em',
  whiteSpace: 'nowrap',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
}));

const WebsiteGroup6 = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '71px',
  height: '9px',
  top: '25px',
  left: '102px'
}));

const WebsiteIcon6 = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '9px',
  height: '9px',
  top: 0,
  left: 0,
  fontSize: '7px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

const WebsiteText6 = styled(Typography)(({ theme }) => ({
  width: 'auto',
  maxWidth: '80px',
  position: 'absolute',
  top: '2px',
  left: '13px',
  fontFamily: 'Inter, Helvetica, Arial, sans-serif',
  fontWeight: 600,
  color: '#ffffff',
  fontSize: '5.3px',
  textAlign: 'center',
  lineHeight: 1.2,
  letterSpacing: 0,
  whiteSpace: 'normal',
  wordWrap: 'break-word'
}));

const AddressSection6 = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '5px',
  width: '100%'
}));

const LocationIcon6 = styled(Box)(({ theme }) => ({
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#fff'
  }
}));

const AddressText6 = styled(Typography)(({ theme }) => ({
  fontFamily: '"Montserrat", sans-serif',
  fontWeight: 600,
  color: '#ffffff',
  fontSize: '14px',
  lineHeight: 1.4,
  letterSpacing: '0.01em',
  wordWrap: 'break-word',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
}));

const CompanyName6 = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: 'white',
  padding: '6px 10px',
  borderRadius: '6px',
  display: 'inline-block'
}));

const CompanyTitle6 = styled(Typography)(({ theme }) => ({
  fontSize: '21px',
  fontWeight: 700,
  letterSpacing: '0.02em',
  lineHeight: 1.3,
  color: '#003f92',
  textAlign: 'center',
  fontFamily: '"Montserrat", sans-serif'
}));

// Business Name Styles with enhanced typography
const BusinessName = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 700,
  color: '#ffffff',
  marginBottom: '8px',
  lineHeight: 1.2,
  textShadow: '0 1px 2px rgba(0,0,0,0.3)',
  letterSpacing: '0.5px'
}));

// Contact Info Container with better spacing
const ContactInfo = styled(Stack)(({ theme }) => ({
  gap: '4px',
  position: 'relative',
  zIndex: 1
}));

// Info Text Styles with better readability
const InfoText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '10px',
  fontWeight: 400,
  color: '#ffffff',
  opacity: 0.95,
  lineHeight: 1.4,
  textShadow: '0 1px 1px rgba(0,0,0,0.2)'
}));

const ContactText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '12px',
  fontWeight: 600,
  color: '#ffffff',
  opacity: 1,
  lineHeight: 1.4,
  textShadow: '0 1px 1px rgba(0,0,0,0.2)'
}));

const WebsiteText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '10px',
  fontWeight: 500,
  color: '#ffffff',
  opacity: 1,
  lineHeight: 1.4,
  textDecoration: 'underline',
  textShadow: '0 1px 1px rgba(0,0,0,0.2)',
  '&:hover': {
    opacity: 0.8
  }
}));

const AddressText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '9px',
  fontWeight: 400,
  color: '#ffffff',
  opacity: 0.9,
  lineHeight: 1.3,
  textShadow: '0 1px 1px rgba(0,0,0,0.2)'
}));

// Template 1 - Auto-adjustable layout (color variant #121927)
const FooterContainer1PX = styled(Box)(({ theme }) => ({
  backgroundColor: '#121927',
  color: 'white',
  padding: '8px',
  borderRadius: '0 0 12px 12px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  alignItems: 'center',
  justifyContent: 'center'
}));

const PhoneSection1PX = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5px',
  width: '100%'
}));

const PhoneIcon1PX = styled(Box)(({ theme }) => ({
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#fff'
  }
}));

const PhoneNumber1PX = styled(Typography)(({ theme }) => ({
  fontFamily: '"Roboto Condensed", "Roboto", sans-serif',
  fontWeight: 600,
  color: '#ffffff',
  fontSize: '15px',
  lineHeight: 1.4,
  letterSpacing: '0.02em',
  whiteSpace: 'nowrap',
  textShadow: '0 1px 3px rgba(0,0,0,0.4)'
}));

const WebsiteGroup1PX = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '71px',
  height: '9px',
  top: '25px',
  left: '102px'
}));

const WebsiteIcon1PX = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '9px',
  height: '9px',
  top: 0,
  left: 0,
  fontSize: '7px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

const WebsiteText1PX = styled(Typography)(({ theme }) => ({
  width: 'auto',
  maxWidth: '80px',
  position: 'absolute',
  top: '2px',
  left: '13px',
  fontFamily: 'Inter, Helvetica, Arial, sans-serif',
  fontWeight: 600,
  color: '#ffffff',
  fontSize: '5.3px',
  textAlign: 'center',
  lineHeight: 1.2,
  letterSpacing: 0,
  whiteSpace: 'normal',
  wordWrap: 'break-word'
}));

const AddressSection1PX = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '5px',
  width: '100%'
}));

const LocationIcon1PX = styled(Box)(({ theme }) => ({
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#fff'
  }
}));

const AddressText1PX = styled(Typography)(({ theme }) => ({
  fontFamily: '"Roboto Condensed", "Roboto", sans-serif',
  fontWeight: 600,
  color: '#ffffff',
  fontSize: '14px',
  lineHeight: 1.4,
  letterSpacing: '0.01em',
  wordWrap: 'break-word',
  textShadow: '0 1px 3px rgba(0,0,0,0.4)'
}));

const CompanyName1PX = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: 'white',
  padding: '6px 10px',
  borderRadius: '6px',
  display: 'inline-block'
}));

const CompanyTitle1PX = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 700,
  letterSpacing: '0.03em',
  lineHeight: 1.3,
  color: '#1a1a1a',
  textAlign: 'center',
  fontFamily: '"Roboto Condensed", "Roboto", sans-serif',
  textTransform: 'uppercase'
}));

// Template Footer Variants with unique layouts
// Footer 1 - Centered Layout with Icons
export const TemplateFooter1 = ({ accountInfo, customColor, customFontColor }) => (
  <FooterContainer1PX sx={{ background: customColor ? `linear-gradient(135deg, ${customColor} 0%, ${customColor}dd 100%)` : undefined, color: customFontColor || undefined }}>
    <CompanyName1PX>
      {/* Don't apply customFontColor here - the pill has white background, so text must stay dark */}
      <CompanyTitle1PX>{accountInfo?.businessName || 'URBANTECH SOLUTIONS'}</CompanyTitle1PX>
    </CompanyName1PX>

    <AddressSection1PX>
      <LocationIcon1PX sx={{ stroke: customFontColor || undefined }}>
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      </LocationIcon1PX>
      <AddressText1PX sx={{ color: customFontColor || undefined }}>
        {accountInfo?.address || '2385 SYCAMORE STREET, COLUMBUS, OH 43215'}
      </AddressText1PX>
    </AddressSection1PX>

    <PhoneSection1PX>
      <PhoneIcon1PX sx={{ stroke: customFontColor || undefined }}>
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.59 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.11a2 2 0 0 1 2.11-.45c.84.27 1.71.47 2.61.59A2 2 0 0 1 22 16.92z" />
        </svg>
      </PhoneIcon1PX>
      <PhoneNumber1PX sx={{ color: customFontColor || undefined }}>
        {accountInfo?.contact || '6858653555'}
      </PhoneNumber1PX>
    </PhoneSection1PX>
  </FooterContainer1PX>
);

// Footer 2 - Modern Glassmorphism Design
export const TemplateFooter2 = ({ accountInfo, customColor, customFontColor }) => (
  <FooterContainer2 sx={{ background: customColor ? `linear-gradient(180deg, ${customColor} 0%, ${customColor}dd 100%)` : undefined, color: customFontColor || undefined }}>
    <Card2>
      <TileInner2>
        <Brand2>
          <BrandTitle2 sx={{ color: customFontColor || undefined }}>{accountInfo?.businessName || 'Rasika Electro World'}</BrandTitle2>
          <BrandTag2 sx={{ color: customFontColor || undefined }}>{accountInfo?.tagline || 'Ac dealer | Electronics | Chimney'}</BrandTag2>
        </Brand2>

        <Stack2>
          <Row2>
            <Icon2 sx={{ stroke: customFontColor || undefined }}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.59 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.11a2 2 0 0 1 2.11-.45c.84.27 1.71.47 2.61.59A2 2 0 0 1 22 16.92z" />
              </svg>
            </Icon2>
            <ValueText2 sx={{ color: customFontColor || undefined }}>{accountInfo?.contact || '095697 97120'}</ValueText2>
          </Row2>

          <Row2>
            <Icon2 sx={{ stroke: customFontColor || undefined }}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="5" width="18" height="14" rx="2" ry="2" />
                <polyline points="3,7 12,13 21,7" />
              </svg>
            </Icon2>
            <ValueText2 sx={{ color: customFontColor || undefined }}>{accountInfo?.email || 'e2erasikaelectroworld@gmail.com'}</ValueText2>
          </Row2>
        </Stack2>

        <Stack2 className="addr">
          <Row2>
            <Icon2 sx={{ stroke: customFontColor || undefined }}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </Icon2>
            <AddressValue2 sx={{ color: customFontColor || undefined }}>
              {accountInfo?.address || 'Sco 02, Ground Floor, VIP Road, Ambala - Chandigarh Road, opposite Kohinoor Dhaba'}
            </AddressValue2>
          </Row2>
        </Stack2>
      </TileInner2>
    </Card2>
  </FooterContainer2>
);

// Footer Container 3 - Modern Professional Style
const FooterContainer3 = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #732f00 0%, #8b3a00 50%, #a04400 100%)',
  color: '#ffffff',
  position: 'relative',
  overflow: 'hidden',
  padding: '12px 16px',
  height: '100%',
  borderRadius: '0 0 12px 12px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 12px rgba(115, 47, 0, 0.4)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `
      radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 40%),
      radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.05) 0%, transparent 40%)
    `,
    zIndex: 0
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(90deg, transparent 0%, #ff6b35 50%, transparent 100%)',
    zIndex: 1
  }
}));

const VintageOrnament = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  fontSize: '10px',
  color: '#ffffff',
  opacity: 0.5,
  zIndex: 1
}));

const VintageLogo = styled(Typography)(({ theme }) => ({
  fontFamily: 'Playfair Display, Georgia, serif',
  fontSize: '14px',
  fontWeight: 700,
  color: '#ffffff',
  textShadow: '1px 1px 0px #1a0e08',
  letterSpacing: '0.5px',
  marginBottom: '2px'
}));

const VintageEst = styled(Typography)(({ theme }) => ({
  fontSize: '6px',
  color: '#ffffff',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  border: '1px solid #ffffff',
  padding: '1px 3px',
  background: 'rgba(139, 115, 85, 0.1)',
  display: 'inline-block'
}));

const VintageDivider = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '1px',
  background: '#d4af37',
  margin: '4px 0',
  position: 'relative',
  '&::before': {
    content: '"❦"',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#2d1b16',
    color: '#d4af37',
    padding: '0 3px',
    fontSize: '6px'
  }
}));

const VintageContactLine = styled(Typography)(({ theme }) => ({
  fontSize: '9px',
  color: '#ffffff',
  textAlign: 'center',
  lineHeight: 1.2,
  fontWeight: 600,
  '&.highlight': {
    color: '#ffffff',
    fontWeight: 700,
    fontSize: '8px'
  }
}));

const VintageSocial = styled(Box)(({ theme }) => ({
  width: '16px',
  height: '16px',
  background: '#d4af37',
  color: '#2d1b16',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '6px',
  fontWeight: 'bold',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: '#ffd700',
    transform: 'translateY(-1px)'
  }
}));

const VintageWebsite = styled(Typography)(({ theme }) => ({
  fontSize: '8px',
  color: '#ffffff',
  fontWeight: 'bold',
  textDecoration: 'underline',
  marginBottom: '1px'
}));

const VintageTagline = styled(Typography)(({ theme }) => ({
  fontSize: '5px',
  color: '#ffffff',
  fontStyle: 'italic',
  textTransform: 'uppercase',
  letterSpacing: '0.3px'
}));

// Modern styled components for Template 3
const ModernBusinessName = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, Roboto, system-ui, -apple-system, sans-serif',
  fontSize: '14px',
  fontWeight: 600,
  color: '#ffffff',
  textAlign: 'center',
  marginBottom: '6px',
  letterSpacing: '0.02em',
  textShadow: '0 1px 2px rgba(0,0,0,0.3)',
  position: 'relative',
  zIndex: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%'
}));

const ModernContactRow = styled(Stack)(({ theme }) => ({
  direction: 'row',
  spacing: 2,
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '12px',
  position: 'relative',
  zIndex: 2
}));

const ModernContactItem = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, Roboto, system-ui, -apple-system, sans-serif',
  fontSize: '12px',
  fontWeight: 500,
  color: '#fdfffe',
  lineHeight: 1.3,
  textShadow: '0 1px 1px rgba(0,0,0,0.2)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  '&.phone': {
    fontWeight: 600
  },
  '&.website': {
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8
    }
  }
}));

const ModernAddressText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, Roboto, system-ui, -apple-system, sans-serif',
  fontSize: '8px',
  fontWeight: 500,
  color: '#fdfffe',
  textAlign: 'center',
  lineHeight: 1.4,
  marginTop: '4px',
  opacity: 0.9,
  textShadow: '0 1px 1px rgba(0,0,0,0.2)',
  position: 'relative',
  zIndex: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word'
}));

// Footer 3 - Modern Professional Style
export const TemplateFooter3 = ({ accountInfo, customColor, customFontColor }) => (
  <FooterContainer3 sx={{ background: customColor || undefined, color: customFontColor || undefined }}>
    {/* Business Name */}
    <ModernBusinessName sx={{ color: customFontColor || undefined }}>
      {accountInfo?.businessName || 'Greenpeak Marketing'}
    </ModernBusinessName>

    {/* Contact Information */}
    <ModernContactRow>
      <ModernContactItem className="phone" sx={{ color: customFontColor || undefined }}>
        Contact: {accountInfo?.contact || '+91 875550293'}, {accountInfo?.contact || '+91 875550293'}
      </ModernContactItem>
      <ModernContactItem className="website" sx={{ color: customFontColor || undefined }}>
        Website: {accountInfo?.website || 'www.urbantechusa.com'}
      </ModernContactItem>
    </ModernContactRow>

    {/* Address */}
    <ModernAddressText sx={{ color: customFontColor || undefined }}>
      {accountInfo?.address || 'B-4/168, General Chanda Singh Colony, Near Fountain Chowk, Back Side Bhagat Petrol Pump, Patiala'}
    </ModernAddressText>
  </FooterContainer3>
);

// CTA Button Component
const CtaButton = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #8b4cb8 0%, #6b46c1 100%) !important',
  color: 'white !important',
  border: 'none',
  padding: '6px 20px',
  borderRadius: '25px',
  fontSize: '9px',
  fontWeight: 700,
  cursor: 'pointer',
  transition: 'transform 0.3s ease',
  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '200px',
  '&:hover': {
    transform: 'translateY(-1px)'
  }
}));

const FooterIconSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '15px',
  alignItems: 'center',
  width: '100%',
  overflow: 'hidden'
}));

const FooterItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '6px',
  color: '#333333',
  maxWidth: '33%',
  flex: '1 1 auto',
  minWidth: 0,
  '& > span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));

const FooterIcon = styled(Box)(({ theme }) => ({
  width: '14px',
  height: '14px',
  background: 'rgba(139, 76, 184, 0.1)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '7px'
}));

const FooterTextGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1px',
  fontSize: '6px',
  lineHeight: 1.2,
  minWidth: 0,
  flex: 1,
  '& > div': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));

// Footer 4 - Purple Background with White Footer Section
export const TemplateFooter4 = ({ accountInfo, customColor, customFontColor }) => (
  <FooterContainer4 sx={{ background: customColor || undefined }}>
    {/* White Footer Section */}
    <WhiteFootSection>
      {/* CTA Button */}
      <CtaButton sx={{ color: customFontColor ? `${customFontColor} !important` : undefined }}>
        {accountInfo?.businessName || 'BLUE HORIZON TECH'}
      </CtaButton>

      {/* Footer Icons */}
      <FooterIconSection>
        <FooterItem sx={{ color: customFontColor || undefined }}>
          <FooterIcon>🌐</FooterIcon>
          <span>{accountInfo?.website || 'www.website.com'}</span>
        </FooterItem>

        <FooterItem sx={{ color: customFontColor || undefined }}>
          <FooterIcon>📱</FooterIcon>
          <FooterTextGroup>
            <div>{accountInfo?.contact || '+91 4556665663'}</div>
            <div>{accountInfo?.contact || '+91 4556665663'}</div>
          </FooterTextGroup>
        </FooterItem>

        <FooterItem sx={{ color: customFontColor || undefined }}>
          <FooterIcon>📍</FooterIcon>
          <FooterTextGroup>
            <div>{accountInfo?.address || '123 Anywhere St., Any City'}</div>
            <div>123 Anywhere St., Any City</div>
          </FooterTextGroup>
        </FooterItem>
      </FooterIconSection>
    </WhiteFootSection>
  </FooterContainer4>
);

// Banner Footer Components
const BannerLogo = styled(Box)(({ theme }) => ({
  width: '35px',
  height: '35px',
  background: 'rgba(255, 255, 255, 0.2)',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  fontWeight: 'bold',
  color: 'white',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
}));

const BannerCompanyName = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: 'white',
  textShadow: '0 1px 5px rgba(0, 0, 0, 0.3)',
  marginBottom: '2px'
}));

const BannerDescription = styled(Typography)(({ theme }) => ({
  fontSize: '7px',
  color: 'white',
  opacity: 0.9,
  textTransform: 'uppercase',
  letterSpacing: '0.5px'
}));

const ContactRibbon = styled(Box)(({ theme }) => ({
  height: '25px',
  background: '#2d3436',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 15px',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-5px',
    left: 0,
    right: 0,
    height: '5px',
    background: '#2d3436',
    clipPath: 'polygon(0 100%, 5% 0, 15% 0, 20% 100%, 25% 0, 35% 0, 40% 100%, 45% 0, 55% 0, 60% 100%, 65% 0, 75% 0, 80% 100%, 85% 0, 95% 0, 100% 100%)'
  }
}));

const RibbonSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: 'white'
}));

const RibbonIcon = styled(Typography)(({ theme }) => ({
  fontSize: '8px',
  opacity: 0.8
}));

const RibbonText = styled(Typography)(({ theme }) => ({
  fontSize: '6px',
  fontWeight: 500,
  '&.highlight': {
    color: '#74b9ff',
    fontWeight: 'bold'
  },
  '&.phone': {
    color: '#00b894',
    fontWeight: 'bold'
  }
}));

const RibbonDivider = styled(Box)(({ theme }) => ({
  width: '1px',
  height: '10px',
  background: 'rgba(255, 255, 255, 0.2)'
}));

const DecorativeCircle = styled(Box)(({ theme }) => ({
  position: 'absolute',
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.1)',
  pointerEvents: 'none',
  animation: 'float 4s ease-in-out infinite',
  '@keyframes float': {
    '0%, 100%': { transform: 'translateY(0px)', opacity: 0.3 },
    '50%': { transform: 'translateY(-8px)', opacity: 0.6 }
  }
}));

// Template 5 - Responsive NorthBay Design (Auto-resize)
const FooterContainer5 = styled(Box)(({ theme }) => ({
  backgroundColor: '#1a4d5c',
  color: 'white',
  padding: '8px',
  borderRadius: '0 0 12px 12px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}));

const HeaderContent5 = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  alignItems: 'center'
}));

const CompanyName5 = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: 'white',
  padding: '6px 10px',
  borderRadius: '6px',
  display: 'inline-block'
}));

const CompanyTitle5 = styled(Typography)(({ theme }) => ({
  fontSize: '22px',
  fontWeight: 700,
  letterSpacing: '0.02em',
  lineHeight: 1.3,
  color: '#2c3e50',
  fontFamily: '"Poppins", sans-serif',
  fontStyle: 'normal'
}));

const ContactSection5 = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  alignItems: 'center'
}));

const ContactInfo5 = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px'
}));

const ContactItem5 = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  justifyContent: 'center'
}));

const IconCircle5 = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: '18px',
  height: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  borderRadius: '50%',
  '& svg': {
    width: '11px',
    height: '11px',
    stroke: 'white'
  }
}));

const ContactDetails5 = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1px'
}));

const ContactLink5 = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  textDecoration: 'none',
  fontSize: '16px',
  lineHeight: 1.4,
  fontWeight: 600,
  fontFamily: '"Poppins", sans-serif',
  letterSpacing: '0.01em',
  '&:hover': {
    color: '#ffffff'
  }
}));

const AddressSection5 = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '5px'
}));

const AddressText5 = styled(Typography)(({ theme }) => ({
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: 1.4,
  color: '#ffffff',
  fontWeight: 600,
  fontFamily: '"Poppins", sans-serif',
  letterSpacing: '0.01em'
}));

export const TemplateFooter5 = ({ accountInfo, customColor, customFontColor }) => {
  const businessName = accountInfo?.businessName || 'NorthBay Logistics';
  const contact = accountInfo?.contact || '+123-456-7890';
  const address = accountInfo?.address || 'B-4/168, General Chanda Singh Colony, Near Fountain Chowk, Back Side Bhagat Petrol Pump, Patiala';

  return (
    <FooterContainer5 sx={{ background: customColor ? `linear-gradient(135deg, ${customColor} 0%, ${customColor}dd 100%)` : undefined, color: customFontColor || undefined }}>
      <HeaderContent5>
        {/* Company Name */}
        <CompanyName5>
          {/* Don't apply customFontColor here - the pill has white background, so text must stay dark */}
          <CompanyTitle5>{businessName}</CompanyTitle5>
        </CompanyName5>

        {/* Address */}
        <AddressSection5>
          <IconCircle5 sx={{ stroke: customFontColor || undefined }}>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </IconCircle5>
          <AddressText5 sx={{ color: customFontColor || undefined }}>{address}</AddressText5>
        </AddressSection5>



        {/* Contact Information */}
        <ContactSection5>
          <ContactItem5>
            <IconCircle5 sx={{ stroke: customFontColor || undefined }}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </IconCircle5>
            <ContactLink5 sx={{ color: customFontColor || undefined }}>{contact}</ContactLink5>
          </ContactItem5>
        </ContactSection5>
      </HeaderContent5>
    </FooterContainer5>
  );
};

// Footer 6 - Blue gradient info bar with company pill
export const TemplateFooter6 = ({ accountInfo, customColor, customFontColor }) => (
  <FooterContainer6 sx={{ background: customColor ? `linear-gradient(135deg, ${customColor} 0%, ${customColor}ee 100%)` : undefined, color: customFontColor || undefined }}>
    <CompanyName6>
      {/* Don't apply customFontColor here - the pill has white background, so text must stay dark */}
      <CompanyTitle6>{accountInfo?.businessName || 'URBANTECH SOLUTIONS'}</CompanyTitle6>
    </CompanyName6>

    <AddressSection6>
      <LocationIcon6 sx={{ stroke: customFontColor || undefined }}>
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      </LocationIcon6>
      <AddressText6 sx={{ color: customFontColor || undefined }}>
        {accountInfo?.address || '2385 SYCAMORE STREET, COLUMBUS, OH 43215'}
      </AddressText6>
    </AddressSection6>

    <PhoneSection6>
      <PhoneIcon6 sx={{ stroke: customFontColor || undefined }}>
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.59 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.11a2 2 0 0 1 2.11-.45c.84.27 1.71.47 2.61.59A2 2 0 0 1 22 16.92z" />
        </svg>
      </PhoneIcon6>
      <PhoneNumber6 sx={{ color: customFontColor || undefined }}>
        {accountInfo?.contact || '6858653555'}
      </PhoneNumber6>
    </PhoneSection6>
  </FooterContainer6>
);

// Main component that selects the appropriate footer variant
const TemplateFooterVariants = ({ designId, accountInfo, customColor, customFontColor }) => {
  const footerComponents = {
    1: TemplateFooter1,
    2: TemplateFooter2,
    3: TemplateFooter3,
    4: TemplateFooter4,
    5: TemplateFooter5New,  // Using NEW redesigned template 5 with curved business card
    6: TemplateFooter6New   // Using NEW redesigned template 6 with wave design
  };

  const FooterComponent = footerComponents[designId] || TemplateFooter1;

  return <FooterComponent accountInfo={accountInfo} customColor={customColor} customFontColor={customFontColor} />;
};

export default TemplateFooterVariants;
